/** @jsx jsx */
import { gql } from '@apollo/client';
import { Col } from '@bottlebooks/gatsby-theme-base';
import { graphql } from 'gatsby';
import { jsx } from 'theme-ui';
import BrandContacts from './BrandContacts';
import BrandDescription, { BrandDescriptionFragment } from './BrandDescription';
import BrandFounded, { BrandFoundedFragment } from './BrandFounded';
import BrandRegionSection, {
  BrandRegionSectionFragment,
} from './BrandRegionSection';
import BrandTourism, { BrandTourismFragment } from './BrandTourism';
import BrandVideos, { BrandVideosFragment } from './BrandVideos';
import BrandWinemaker, { BrandWinemakerFragment } from './BrandWinemaker';

export default function BrandDetailsSection({ brand }) {
  return (
    <Col flex>
      <BrandDescription brand={brand} />
      <BrandWinemaker brand={brand} />
      <BrandRegionSection brand={brand} />
      <BrandFounded brand={brand} />
      <BrandTourism brand={brand} />
      <BrandVideos brand={brand} />
      <BrandContacts brand={brand} />
    </Col>
  );
}

export const fragment = graphql`
  fragment bb_BrandDetailsSection on Bottlebooks_AbstractBrand {
    ...BrandDescription
    ...BrandWinemaker
    ...BrandRegionSection
    ...BrandFounded
    ...BrandTourism
    ...BrandVideos
    ...BrandContacts
  }
`;

export const BrandDetailsSectionFragment = gql`
  fragment BrandDetailsSection on AbstractBrand {
    ...BrandDescription
    ...BrandWinemaker
    ...BrandRegionSection
    ...BrandFounded
    ...BrandTourism
    ...BrandVideos
    ...BrandContacts
  }
  ${BrandDescriptionFragment}
  ${BrandWinemakerFragment}
  ${BrandRegionSectionFragment}
  ${BrandFoundedFragment}
  ${BrandTourismFragment}
  ${BrandVideosFragment}
  ${BrandContacts.fragment}
`;
